import { type ReactNode } from "react";

export function SidebarIcon({ children }: { children: ReactNode }) {
  return (
    <span aria-hidden="true" className="flex h-6 w-6 shrink-0 items-center justify-center [&>svg]:h-5 [&>svg]:w-5">
      {children}
    </span>
  );
}
